export const cardData = [
  {
    src: require('@assets/images/safehaven/dashboard/symptoms.svg'),
    desc: 'Not feeling well? Try instant health check to provide you with answers on possible conditions and guide you on the next steps, including access to providers. ',
    title: 'Health Checker',
    linkText: 'Start health checker',
    link: 'isabel-symptom-checker',
    is_active: true,
    key: 'health-check',
  },
  {
    src: require('@assets/images/safehaven/dashboard/Health_Record.svg'),
    desc: 'Get a complete picture of your health including physician visits, lab reports, prescriptions and medical conditions that can be analyzed for potential health risks.',
    title: 'Health Records',
    linkText: 'Add a health record',
    link: '',
    is_active: true,
    key: 'health-record',
  },
  {
    src: require('@assets/images/safehaven/dashboard/upload_file.svg'),
    desc: 'Take ownership of your health information even further. As an owner, you can safely and securely store all your healthcare-related documents in one place. ',
    title: 'Document Center',
    linkText: 'Go to document center',
    link: 'safehaven-health-vault',
    is_active: true,
    key: 'document-center',
  },
]
